interface Props {
  tab: string
  onCreateClick: () => void
}

const TAB_MESSAGES: Record<string, { title: string; description: string }> = {
  active: {
    title: 'No Active Topics',
    description: 'Add topics to The List to discuss in your next meeting.'
  },
  solved: {
    title: 'No Resolved Topics',
    description: 'Topics that have been resolved will appear here with their resolution notes.'
  }
}

export default function TopicEmptyState({ tab, onCreateClick }: Props) {
  const message = TAB_MESSAGES[tab] || TAB_MESSAGES.active

  return (
    <div className="bg-white rounded-lg border border-[#351E1D]/10 p-12 text-center">
      <div className="flex justify-center mb-4">
        <svg className="w-16 h-16 text-text-primary/20" viewBox="0 0 64 64" fill="none">
          <circle cx="32" cy="32" r="28" stroke="currentColor" strokeWidth="2" />
          <circle cx="32" cy="32" r="8" fill="currentColor" opacity="0.3" />
          <line x1="32" y1="4" x2="32" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <line x1="32" y1="52" x2="32" y2="60" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <line x1="4" y1="32" x2="12" y2="32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <line x1="52" y1="32" x2="60" y2="32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </div>
      <h3 className="font-semibold text-text-primary mb-2" style={{ fontSize: '18px' }}>{message.title}</h3>
      <p className="text-text-secondary mb-6 max-w-md mx-auto" style={{ fontSize: '16px' }}>{message.description}</p>
      {tab !== 'solved' && (
        <button
          onClick={onCreateClick}
          className="bg-[#ED1C24] text-white px-5 py-2.5 rounded-lg font-semibold hover:bg-pinnacle-red-dark transition-colors"
          style={{ fontSize: '16px' }}
        >
          Add Topic
        </button>
      )}
    </div>
  )
}
